
export type TFeedbackTypes = 'warning' | 'success' | 'error' | 'info' | undefined

export interface IFeedback {
  message: string;
  onClose?: Function;
  type: TFeedbackTypes;
}


export const feedback = (message: string, type: TFeedbackTypes, onClose?: Function) => {
  dispatchEvent(new CustomEvent('FEEDBACK_EVENT', {
    detail: {
      message,
      onClose,
      type
    }
  }));
};
